import sortBy from 'lodash/sortBy';
import orderBy from 'lodash/orderBy';

import { ItemPosition } from 'Shared/constants/types';

export const sortFilterValues = {
  DATE_COMPLETED: { label: 'Date Completed', value: 'DATE_COMPLETED' },
  DATE_DUE: { label: 'Date Due', value: 'DATE_DUE' },
  OWNER_A_Z: { label: 'Owner (A-Z)', value: 'OWNER_A_Z' },
  OWNER_Z_A: { label: 'Owner (Z-A)', value: 'OWNER_Z_A' },
  WORKSPACE_NAME: { label: 'Workspace name', value: 'WORKSPACE_NAME' },
};

export const getSortFilterValues = tr => ({
  DATE_COMPLETED: { label: tr('perform.utils.sorting.date_completed'), value: 'DATE_COMPLETED' },
  DATE_DUE: { label: tr('perform.utils.sorting.date_due'), value: 'DATE_DUE' },
  OWNER_A_Z: { label: tr('perform.utils.sorting.owner_az'), value: 'OWNER_A_Z' },
  OWNER_Z_A: { label: tr('perform.utils.sorting.owner_za'), value: 'OWNER_Z_A' },
  WORKSPACE_NAME: { label: tr('perform.utils.sorting.workspace_name'), value: 'WORKSPACE_NAME' },
});

export function sortByHighPriority(array) {
  return [...array].sort((a, b) => {
    if (a.isHighPriority > b.isHighPriority) return -1;
    if (a.isHighPriority < b.isHighPriority) return 1;
    return 0;
  });
}

export function sortAndFilterCategories(categories) {
  categories.sort((a, b) => {
    if (a.name === "Don't track") return 1;
    if (b.name === "Don't track") return -1;

    return b.time - a.time;
  });

  return categories.filter(category => category.time > 0);
}

export function buildMeetingItemsPositions(meetingItems, positionField = ItemPosition.positionForWorkspacePage) {
  let position = 1;
  const sortedMeetingItems = [];
  meetingItems
    .filter(meetingItem => !meetingItem.parentId)
    .forEach(meetingItem => {
      sortedMeetingItems.push({ ...meetingItem, [positionField]: position });
      position += 1;

      const childrenItems = meetingItems.filter(({ parentId }) => parentId === meetingItem.id);
      if (childrenItems.length > 0) {
        childrenItems.forEach(childMeetingItem => {
          sortedMeetingItems.push({ ...childMeetingItem, [positionField]: position });
          position += 1;
        });
      }
    });
  return sortedMeetingItems;
}

export function getSortedItemsBySortId({ items, sortId, direction }) {
  if (sortId === 'actionItems')
    return orderBy(items, [({ body }) => JSON.parse(body).blocks[0].text.toLowerCase()], [direction]);
  if (sortId === 'owner')
    return orderBy(
      items,
      [({ assignmentAvatar }) => assignmentAvatar && assignmentAvatar.label, ({ isHighPriority }) => !isHighPriority],
      [direction, 'asc']
    );
  if (sortId === 'dueDate') return orderBy(items, [({ dueBy }) => dueBy || 0], [direction]);
  if (sortId === 'workspace')
    return orderBy(items, [({ displayLabel, workspaceName }) => displayLabel || workspaceName], [direction]);
  return items;
}

export function getSortedItems({
  items,
  selectedSort,
  withHighPriority,
  positionField = 'positionForActionItemsPage',
}) {
  const sortId = selectedSort
    ? Object.keys(selectedSort).find(sortOption => selectedSort[sortOption] !== 'default')
    : null;

  if (!sortId) return sortByHighPriority(sortBy(items, item => item[positionField]));

  const direction = selectedSort[sortId] === 'ascending' ? 'asc' : 'desc';
  const sortedItems = getSortedItemsBySortId({ items, sortId, direction });
  return withHighPriority ? sortByHighPriority(sortedItems) : sortedItems;
}

export function sortedClosedActionItems({ sortFilterValue, closedActionItems }) {
  switch (sortFilterValue.value) {
    case sortFilterValues.DATE_DUE.value:
      return sortBy(closedActionItems, ({ dueBy }) => dueBy);
    case sortFilterValues.OWNER_A_Z.value:
      return sortBy(closedActionItems, ({ assignee: { personName } }) => personName);
    case sortFilterValues.OWNER_Z_A.value:
      return sortBy(closedActionItems, ({ assignee: { personName } }) => personName).reverse();
    case sortFilterValues.WORKSPACE_NAME.value:
      return sortBy(closedActionItems, ({ workspaceName }) => workspaceName);
    default:
      return sortBy(closedActionItems, ({ createdAt }) => createdAt).reverse();
  }
}

export function sortUsersByName(users) {
  return sortBy(users, user => user.fullName || user.email);
}
